import { useEffect, useState, useRef } from "react";
import { FaRegFile, FaHistory, FaDownload, FaComment, FaComments, FaCog, FaRegUserCircle, FaList, FaTimes, FaColumns, FaRegFilePdf, FaCode, FaExclamationTriangle, FaTimesCircle, FaPaperclip, FaFileAlt, FaFileArchive, FaPencilAlt, FaImage, FaFileInvoice, FaLock, FaFileDownload, FaSpellCheck, FaVideo } from "react-icons/fa";
import { BiSolidFileJson, BiSolidCommentEdit } from 'react-icons/bi';
import { IoMdCodeDownload } from "react-icons/io";
import { MdHelpOutline } from "react-icons/md";
import Logo from "../../images/iAuthorFileIcon.png";
import Loader from "../../images/loader.gif";
import { TocTab, AttachementTab, HistoryTab, ImagelistTab, SupplementaryTab, VideoTab } from "../leftsidecontent";
import { AuthorQueryTab, CommentTab, TrackChanges, TrackChangeandComment } from "../rightsidecontent";
import PdfEditor from "../pdfeditor";
import { Button, Form, Table, Offcanvas } from 'react-bootstrap';
import './layout.scss';
import Split from '@uiw/react-split';
import integraLogo from "../../images/integra.png";
import { settingForm } from "./formjson";
import CodeMirrorEditor, { setAltTextClickHandler } from "../editor";
// Ref for imperative handle to editor
import pathconfig from '../../pathconfig.json';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import { toastError, toastSuccess, toastWarning } from '../toaster';
import moment from 'moment';
import io from 'socket.io-client';
import packjson from '../../../package.json';
import { useAppContextProvider } from '../../contextapi';
import { spellCheckField, spellCheckSettingsOptions } from "../editor/extension/spellChecker";
import InlpTab from "../rightsidecontent/inlpTab";
import { AiOutlineHistory } from "react-icons/ai";
import useSessionTimeout from '../../hooks/useSessionTimeout';

const Layout = (props) => {
    const editorImperativeRef = useRef();
    const [sidebar, setSidebar] = useState('rightbar');
    const [leftsidebarvalue, setLeftsidebarvalue] = useState('fileview')
    const [rightsidebarvalue, setRightsidebarvalue] = useState('query')
    const [errorCompile, setErrorCompile] = useState([]);
    const [errorCompileFullData, setErrorCompileFullData] = useState([]);
    const [errorShow, setErrorShow] = useState(false);
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    // const [settingGroup, setSettingGroup] = useState(settingForm)
    const [loader, setLoader] = useState(true)
    const [fileProgess, setFileProgess] = useState(false);
    const [render, setRender] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [downloadTrigger, setdownloadTriger] = useState(false);
    const [errorTab, setErrorTab] = useState('errorlog');
    const [logFile, setLogFile] = useState('');
    const [filestatus, setFilestatus] = useState(false);
    const [lastsavedTime, setLastsavedTime] = useState();
    const [dragTrigger, setDragTrigger] = useState(false);
    const [validationdata, setValidationdata] = useState([]);
    const [itemFile, setItemFile] = useState([]);
    const [showProgress, setShowprogress] = useState(false);
    const [dowloadTrackFile, setDownloadTrackFile] = useState(false);
    const [filters, setFilters] = useState({
        Error: true, // Default to true for "Error"
        Warning: true // Default to true for "Warning"
    });
    const [toggleLayout, setToggleLayout] = useState(false);
    const { userProfile, setUserProfile, setLineFocus, setAuthorQuery, setTrackChangeBlob, setCommentValue, setCommentRange, commentSidebar, setMicroSave, fullData, setFullData, layout, setLayout, setEditorStyle, readOnly, setReadOnly, sideBarClose, setSidebarClose, setSupplementaryGetData, trackChanges, fileContentData, editorContent, setCommentSidebar, setCloseErrorLog, closeErrorLog, setAttachmentContent, attachmentContent, setSavedInlpActions, inlpActions, setIsDataReady, alttextEnabled, setAlttextEnabled } = useAppContextProvider();
    const [logStatus, setLogStatus] = useState(false);
    const [articleStatus, setArticleStatus] = useState(false);
    const [ActivityName, setActivityName] = useState('');
    const toggleRef = useRef(null);
    const [underMaintenance, setUnderMaintenance] = useState(false);
    const [isAttachmentLoaded, setIsAttachmentLoaded] = useState(false);
    const [apiCalled, setApiCalled] = useState(false);
    const [isDetailsFetched, setIsDetailsFetched] = useState(false); // New state variable
    const logTabBtnRef = useRef(null);
    const pdfEditorRef = useRef(null);
    // const trackChangesBtnRef = useRef(null);

    let sockectCheck = false;
    const updatedSettingForm = [
        ...settingForm,
        {
            label: "Spell Check",
            value: "us",
            fieldType: "spellcheck",
            option: spellCheckSettingsOptions
        }
    ];
    const [settingGroup, setSettingGroup] = useState(updatedSettingForm)
    const [spellCheckSettings, setSpellCheckSettings] = useState({
        enabled: false,
        us: true,
        uk: false
    });
    const [progressDetails, setProgressDetails] = useState('Please wait auto compiler in progress.')
    const [announcement, setAnnouncement] = useState('')
    const [isLoggingOut, setIsLoggingOut] = useState(false); // State to track logout process
    const [altTextContent, setAltTextContent] = useState({});
    const [supplementComments, setSupplementComments] = useState({});

    const handleLogout = async () => {
        if (readOnly) return;
        setIsLoggingOut(true); // Start logout process
        let docId = userProfile?.docid || location.search.split('?')[1]?.split('=')[1];
        if (pdfEditorRef.current) {
            try {
                // Attempt to save before logging out
                await pdfEditorRef.current.saveDocument();
            } catch (error) {
                console.error("Auto-save on timeout failed", error);
            }
        }
        navigate(`/notification?docid=${docId}`, { state: { status: 'error', Message: 'Your session has expired due to inactivity. Please refresh the page to continue.' } });
        setIsLoggingOut(false);
    };

    const { isWarning, resetTimer } = useSessionTimeout({
        onTimeout: handleLogout,
    });

    useEffect(() => {
        let activeSocket = null;
        if (underMaintenance) {
            navigate('/underconstruction');
        }
        else {
            let docId = location.search.split('?')[1].split('=')[1];

            if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
                navigate(`/notification?docid=${docId}`, { state: { 'device': 'mobile' } })
            }

            const initializeSocket = async () => {
                activeSocket = await setupSocketConnection(docId);
            };

            initializeSocket();

            let themeValue = localStorage.getItem('theme');
            if (themeValue == null) {
                localStorage.setItem('theme', 'blue-theme');
                themeValue = 'blue-theme';
                settingGroup[1].value = 'blue-theme';
                setSettingGroup([...settingGroup]);
            }
            else {
                settingGroup[1].value = themeValue;
                setSettingGroup([...settingGroup]);
            }
            document.body.classList.add(themeValue);
            getDocdata(docId);
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
                if (activeSocket) {
                    activeSocket.disconnect();
                }
            };
        }
    }, [underMaintenance]);

    const setupSocketConnection = async (docId) => {
        // console.log('<<<location.pathname {{{True}}}>>>', location.pathname.includes('/notification'));
        // if (location.pathname.includes('/notification')) return;
        try {
            let iAsocketUrl = `${pathconfig[packjson.environment].iAsocketUrl}`;
            console.log('<<<iAsocketUrl>>>', iAsocketUrl);

            const iAsocket = io.connect(iAsocketUrl, {
                transports: ['websocket', 'polling', 'flashsocket']
            });
            iAsocket.on('connect', async function () {
                console.log('Socket Connected');
                let result = await createRoom(docId, iAsocket);
                var Roomjoinedcount = JSON.parse(result).isRommJoined;
                if (Roomjoinedcount === 0) {
                    // window.location.href = 'https://www.surveymonkey.com/r/HMBCDK5?JID=ELS&AID=33BAF209';
                    iAsocket.disconnect();
                    // navigate(`/notification?docid=${docId}`, { state: 'error' })
                    sockectCheck = true;
                }
            });
            iAsocket.on('disconnect', function (resaon) {
                console.log('Socket Disconnected: Reason' + resaon);
            });
            return iAsocket;
        } catch (error) {
            console.error('Error in socket connection:', error);
        }
    };

    const updateSpellCheckSettings = (settings) => {
        setSpellCheckSettings(settings);
        // Dispatch an event to notify the editor about settings change
        const event = new CustomEvent('spellCheckSettingsChanged', {
            detail: settings
        });
        document.dispatchEvent(event);
    };

    function createRoom(docid, iAsocket) {
        return new Promise((resolve, reject) => {
            try {
                var docObj = {
                    docID: docid
                }; // format for sending docID
                docObj.isCollaborative = false; //optional
                iAsocket.on('createRoom', function (data) {
                    console.log(data, 'Room created');
                    resolve(data);
                });
                iAsocket.emit('createRoom', JSON.stringify(docObj));
            } catch (e) { resolve('{}') }
        });
    }

    useEffect(() => {
        if (commentSidebar?.showSidebar === 'rightbar') {
            setSidebar(commentSidebar.showSidebar);
            setRightsidebarvalue(commentSidebar.commentValue);
        }
        if (sideBarClose) {
            setSidebar('');
            setLeftsidebarvalue('');
            setRightsidebarvalue('');
            setSidebarClose(false);
            setCommentSidebar({ selectValue: '', showSidebar: '', commentValue: '' })
        }
        if (!errorShow) {
            setCloseErrorLog(false);
        }
    }, [commentSidebar, sideBarClose, errorShow]);

    const slidebarHandle = (type, value) => {
        if (sidebar === 'leftbar') {
            setLeftsidebarvalue(value)
        } else {
            setSidebar(type)
            setLeftsidebarvalue(value)
            setRightsidebarvalue('')
        }

        // Set announcement for screen readers
        const tabNames = {
            'attachement': 'Attachment tab',
            'toc': 'Table of content tab',
            'history': 'History tab',
            'image': 'Image tab',
            'supplementary': 'Supplementary tab',
            'video': 'Video tab'
        };
        if (tabNames[value]) {
            setAnnouncement(`${tabNames[value]} button clicked`);
            setTimeout(() => setAnnouncement(''), 1000);
        }
    }

    // const getDocdata = async (value) => {
    //     let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_Doc_Details}`;
    //     let docid = value;
    //     const maxRetries = 3;
    //     const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    //     for (let attempt = 1; attempt <= maxRetries; attempt++) {
    //         try {
    //             const response = await axios.get(`${url}?docid=${docid}`);

    //             //setSidebar('')
    //             setLeftsidebarvalue('')
    //             setFullData(response.data);
    //             setLoader(false);
    //             console.log(response.data, 'response.data')
    //             let responseTrue = response.data.TocDetails.oData.ActivtyDetails.isPreviewMode === 1 ? true : false;
    //             if (sockectCheck) {
    //                 setReadOnly(sockectCheck)
    //                 toastWarning('This article is currently locked by another user.');
    //                 setLogStatus(sockectCheck)
    //             } else {
    //                 setReadOnly(responseTrue);
    //                 setArticleStatus(responseTrue);
    //             }
    //             setAuthorQuery(JSON.parse(response.data.queryContent));
    //             setCommentValue({ comment: JSON.parse(response.data.commentContent).comment, changeIndex: null });
    //             // setCommentRange(response.data.rangeCommentContent === '{}' ? [] : JSON.parse(response.data.rangeCommentContent));
    //             let Trackdata = response.data.trackchangesContent === '{}' ? [] : JSON.parse(response.data.trackchangesContent);
    //             setTrackChangeBlob(Trackdata);
    //             let supplementaryGet = response.data.supplementaryContent && response.data.supplementaryContent !== '{}'
    //                 ? JSON.parse(response.data.supplementaryContent)
    //                 : [];
    //             setSupplementaryGetData(supplementaryGet);
    //             const dataString = JSON.stringify(response.data.TocDetails.oData);
    //             localStorage.setItem(`${docid}_init-getdetails`, dataString)
    //             const ActivityName = JSON.parse(dataString);
    //             let GetDetailData = response.data.TocDetails.oData.ActivtyDetails.userDetails;
    //             let activityId = response.data.TocDetails.oData.ActivtyDetails.ActivityID;
    //             setActivityName(ActivityName.ActivtyDetails.ActivityName);
    //             if (GetDetailData) {
    //                 setUserProfile({ username: GetDetailData.Name, role: GetDetailData.roleName, docid: docid, ActivityID: activityId, logContent: response.data.logContent });
    //             }
    //             props.StartTour(true);
    //             return;
    //         } catch (error) {
    //             console.log(`Attempt ${attempt} failed.`, error);
    //             if (attempt < maxRetries) {
    //                 await delay(5000); // 5-second delay before the next retry
    //             } else {
    //                 console.log('Max retries reached. Redirecting...');
    //                 navigate(`/notification?docid=${docid}`, { state: { status: 'error', Message: error.message } });
    //             }
    //         }
    //     }
    // }
    // Modify the getDocdata function:
    // const getDocdata = async (value) => {
    //     let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_Doc_Details}`;
    //     let docid = value;
    //     const maxRetries = 3;
    //     const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    //     for (let attempt = 1; attempt <= maxRetries; attempt++) {
    //         try {
    //             // Get Doc Details
    //             const response = await axios.get(`${url}?docid=${docid}`);

    //             // Get Attachment Details
    //             let GetDetailData = response.data.TocDetails.oData;
    //             const getUrl = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].getAttachment}`;
    //             const body = {
    //                 "Proof_Type": GetDetailData.jobdetails.ProofType,
    //                 "JobGUID": GetDetailData.jobdetails.JobGUID,
    //                 "docid": docid
    //             }
    //             const attachmentResponse = await axios.post(getUrl, body);

    //             // Process attachment data
    //             let dataChange = attachmentResponse.data.data.map((item) => ({
    //                 ...item,
    //                 filetype: item.Filename.split('.')[1],
    //             }));
    //             let fileFilter = dataChange.filter(item => item.AttachType !== "gallery");
    //             setItemFile(fileFilter);

    //             // Process doc details data
    //             setLeftsidebarvalue('')
    //             setFullData(response.data);
    //             setLoader(false);

    //             let responseTrue = response.data.TocDetails.oData.ActivtyDetails.isPreviewMode === 1 ? true : false;
    //             if (sockectCheck) {
    //                 setReadOnly(sockectCheck)
    //                 toastWarning('This article is currently locked by another user.');
    //                 setLogStatus(sockectCheck)
    //             } else {
    //                 setReadOnly(responseTrue);
    //                 setArticleStatus(responseTrue);
    //             }

    //             setAuthorQuery(JSON.parse(response.data.queryContent));
    //             setCommentValue({ comment: JSON.parse(response.data.commentContent).comment, changeIndex: null });
    //             let Trackdata = response.data.trackchangesContent === '{}' ? [] : JSON.parse(response.data.trackchangesContent);
    //             setTrackChangeBlob(Trackdata);
    //             let supplementaryGet = response.data.supplementaryContent && response.data.supplementaryContent !== '{}'
    //                 ? JSON.parse(response.data.supplementaryContent)
    //                 : [];
    //             setSupplementaryGetData(supplementaryGet);

    //             const dataString = JSON.stringify(response.data.TocDetails.oData);
    //             localStorage.setItem(`${docid}_init-getdetails`, dataString)
    //             const ActivityName = JSON.parse(dataString);
    //             let activityId = response.data.TocDetails.oData.ActivtyDetails.ActivityID;
    //             setActivityName(ActivityName.ActivtyDetails.ActivityName);

    //             if (GetDetailData.ActivtyDetails.userDetails) {
    //                 setUserProfile({ 
    //                     username: GetDetailData.ActivtyDetails.userDetails.Name, 
    //                     role: GetDetailData.ActivtyDetails.userDetails.roleName, 
    //                     docid: docid, 
    //                     ActivityID: activityId, 
    //                     logContent: response.data.logContent 
    //                 });
    //             }
    //             props.StartTour(true);
    //             return;

    //         } catch (error) {
    //             console.log(`Attempt ${attempt} failed.`, error);
    //             if (attempt < maxRetries) {
    //                 await delay(5000);
    //             } else {
    //                 console.log('Max retries reached. Redirecting...');
    //                 navigate(`/notification?docid=${docid}`, { state: { status: 'error', Message: error.message } });
    //             }
    //         }
    //     }
    // };
    const getDocdata = async (value) => {
        // debugger
        if (apiCalled) return;
        setIsDataReady(false);

        let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_Doc_Details}`;
        let docid = value;
        // const maxRetries = 3;
        // const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

        // for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            // Fetch document data
            const response = await axios.get(`${url}?docid=${docid}`);
            setFullData(response.data);
            const inlpContent = JSON.parse(response?.data?.inlpContent || '[]');
            setSavedInlpActions(inlpContent);

            let alttextdata = response.data.isAltTextFlow;

            // Set alttextEnabled from API response
            setAlttextEnabled(alttextdata);

            // Parse altTextContent and supplementComments only when alttextEnabled
            if (alttextdata) {
                let parsedAltTextContent = {};
                if (response.data.altTextContent && response.data.altTextContent !== '{}') {
                    try {
                        parsedAltTextContent = JSON.parse(response.data.altTextContent);
                    } catch (e) {
                        console.error('Error parsing altTextContent:', e);
                        parsedAltTextContent = {};
                    }
                }
                setAltTextContent(parsedAltTextContent);

                let parsedSupplementComments = {};
                if (response.data.supplementComments && response.data.supplementComments !== '{}') {
                    try {
                        parsedSupplementComments = JSON.parse(response.data.supplementComments);
                    } catch (e) {
                        console.error('Error parsing supplementComments:', e);
                        parsedSupplementComments = {};
                    }
                }
                setSupplementComments(parsedSupplementComments);
            }

            setLoader(false);
            setApiCalled(true);
            let responseTrue = response.data.TocDetails.oData.ActivtyDetails.isPreviewMode === 1 ? true : false;
            if (sockectCheck) {
                setReadOnly(sockectCheck);
                toastWarning('This article is currently locked by another user.');
                setLogStatus(sockectCheck);
            } else {
                setReadOnly(responseTrue);
                setArticleStatus(responseTrue);
            }

            setAuthorQuery(JSON.parse(response.data.queryContent));
            setCommentValue({ comment: JSON.parse(response.data.commentContent).comment, changeIndex: null });
            let Trackdata = response.data.trackchangesContent === '{}' ? [] : JSON.parse(response.data.trackchangesContent);
            setTrackChangeBlob(Trackdata);
            let supplementaryGet = response.data.supplementaryContent && response.data.supplementaryContent !== '{}'
                ? JSON.parse(response.data.supplementaryContent)
                : [];
            setSupplementaryGetData(supplementaryGet);

            const dataString = JSON.stringify(response.data.TocDetails.oData);
            localStorage.setItem(`${docid}_init-getdetails`, dataString);
            const ActivityName = JSON.parse(dataString);
            let activityId = response.data.TocDetails.oData.ActivtyDetails.ActivityID;
            setActivityName(ActivityName.ActivtyDetails.ActivityName);

            if (response.data.TocDetails.oData.ActivtyDetails.userDetails) {
                setUserProfile({
                    username: response.data.TocDetails.oData.ActivtyDetails.userDetails.Name,
                    role: response.data.TocDetails.oData.ActivtyDetails.userDetails.roleName,
                    docid: docid,
                    ActivityID: activityId,
                    logContent: response.data.logContent
                });
            }

            // Fetch attachment data only if it hasn't been loaded yet
            if (itemFile.length === 0 && !isDetailsFetched) {
                await getDetails(docid);
            }

            setIsAttachmentLoaded(true); // Mark attachment data as loaded
            props.StartTour(true);
            return;
        } catch (error) {
            console.log(error);
            navigate(`/notification?docid=${docid}`, { state: { status: 'error', Message: error.message } });
            // if (attempt < maxRetries) {
            //     await delay(5000);
            // } else {
            //     console.log('Max retries reached. Redirecting...');
            //     navigate(`/notification?docid=${docid}`, { state: { status: 'error', Message: error.message } });
            // }
        } finally {
            setIsDataReady(true);
        }
        // }
    };

    const downloadzipfolder = async () => {
        let GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
        setShowprogress(true);
        let GetDetailData = JSON.parse(GetDetailDataString);
        try {
            let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].supportingFileDownload}`;
            const data = {
                docid: userProfile.docid,
            }
            const response = await axios.post(url, data);
            // console.log(response, 'response file');
            const byteCharacters = atob(response.data.base64);
            const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            // Create a Blob from the binary data
            const blob = new Blob([byteArray], { type: 'application/zip' });
            // Create a temporary anchor tag
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${GetDetailData.Articledetails.ArticleName}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setShowprogress(false);
        } catch (error) {
            toastError(`${error.response.data.error}`);
            setShowprogress(false);
        }
    }

    const rightBarHandle = (type, value) => {
        if (sidebar === 'rightbar') {
            setRightsidebarvalue(value)
        } else {
            setSidebar(type)
            setRightsidebarvalue(value)
            setLeftsidebarvalue('')
        }

        // Set announcement for screen readers
        const tabNames = {
            'query': 'Author Query tab',
            'comment': 'Comment tab',
            'trackchanges': 'Track Changes tab',
            'inlp': 'INLP Suggestions tab',
            'tackandcomment': 'Track Changes and Comment tab'
        };
        if (tabNames[value]) {
            setAnnouncement(`${tabNames[value]} button clicked`);
            setTimeout(() => setAnnouncement(''), 1000);
        }
    }

    const compileError = (errorValue) => {
        if (errorValue) {
            setErrorCompile(errorValue);
            setErrorCompileFullData(errorValue);
            setErrorTab('errorlog');
            setErrorShow(true);
        }
    }

    // Add a new function specifically for compilation start
    const closeErrorOnCompile = () => {
        setErrorShow(false);
        setCloseErrorLog(false);
    }

    const layoutOption = (type) => {
        setLayout(type)
        setToggleLayout(false) // Add this line to hide dropdown after selection
        setToggleLayout(!toggleLayout)
    }

    const handleClose = () => {
        setShowOffcanvas(false)
    }

    const handleForm = (index, e, type) => {
        if (type === 'theme') {
            localStorage.setItem('theme', e.target.value)
            let bodyClass = document.body.classList;

            // Remove any existing theme class (classes that end with '-theme') to avoid stacking
            Array.from(bodyClass).filter(c => c.endsWith('-theme')).forEach(c => bodyClass.remove(c));

            document.body.classList.add(e.target.value);
            setRender(!render)
        } else if (type === 'spellcheck') {
            const value = e.target.value;
            const newSettings = {
                ...spellCheckSettings,
                enabled: spellCheckSettings.enabled,
                us: value === 'both' || value === 'us',
                uk: value === 'both' || value === 'uk'
            };
            setSpellCheckSettings(newSettings);

            // Dispatch event with new settings
            const event = new CustomEvent('spellCheckSettingsChanged', {
                detail: newSettings
            });
            document.dispatchEvent(event);
        }

        settingGroup[index].value = e.target.value;
        setSettingGroup([...settingGroup]);
        setRender(!render)
    }

    const fileSave = (value) => {
        setFileProgess(value)
    }

    const fileSaveStatus = (val) => {
        setFilestatus(val)
        setLastsavedTime(new Date())
    }

    const [imageToHighlight, setImageToHighlight] = useState(null);

    const errorFocus = (line) => {
        // If this is an image validation error, open the image sidebar and highlight (only when alttextEnabled)
        if (alttextEnabled && (line.position === "Image" || line.fileName)) {
            setSidebar("leftbar");
            setLeftsidebarvalue("image");
            setSidebarClose(false);
            setImageToHighlight(line.fileName || null);
            return;
        }

        setLineFocus(null);
        setTimeout(() => {
            setLineFocus(line);
        }, 500);
    }

    const downloadFile = () => {
        try {
            setdownloadTriger(true)
            setTimeout(() => {
                setdownloadTriger(false)
            }, 1000);
        } catch (error) {
            setdownloadTriger(false); // Reset trigger in case of error
            toastError(`Error downloading file: ${error.message}`);
        }
    };

    const logTab = (val) => {
        setErrorTab(val)
        setErrorShow(true);
    }

    const errorLogShow = () => {
        setLogFile('')
        setErrorShow(true);
        setErrorTab('log')
        getLogData();
    }

    const LogDataFile = (val) => {
        if (val) {
            getLogData()
        }
    }

    const getLogData = async () => {
        let GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
        let GetDetailData = JSON.parse(GetDetailDataString);
        let outputLogPath = GetDetailData.Articledetails.OutputPath.replace('.xml', '.log')
        const url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].blobFileExistorNot}`;
        const data = {
            InputPath: outputLogPath,
        }
        const isFileexist = await axios.post(url, data);
        if (isFileexist.data.exist === true) {
            const response = await axios.post(`${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].get_log_details}`, {
                blobUrl: outputLogPath,
            });
            LogData(response.data.logBase64)
        }
    }

    const LogData = (logvalue) => {
        if (logvalue) {
            // Step 1: Decode the base64-encoded log data to a byte array
            const byteCharacters = atob(logvalue);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            // Step 2: Convert the byte array to a string
            const logString = new TextDecoder().decode(byteArray);
            // Step 3: Display the decoded log data
            setLogFile(logString)
            // Optionally, you can use the logString as needed, for example:
            // - Set it in a state for a React component
            // - Display it in an HTML element
            // - Write it to a file (if in a Node.js environment)
            // Example of setting the decoded log string in a React component state
            // setLogData(logString);
        }
    }

    const handleDragEnd = () => {
        setDragTrigger(false)
        setTimeout(() => {
            setDragTrigger(true)
        }, 100);
    };

    const validation = (value) => {
        if (value.length > 0) {
            setValidationdata(value)
            setErrorTab('validation')
            setErrorShow(true);
        } else {
            setValidationdata([])
        }
    }

    const reloadData = (status) => {
        if (status) {
            getDocdata(userProfile.docid);
            setSidebar('');
            setLeftsidebarvalue('');
        }
    }

    const getTrigger = (item) => {
        if (item === true && !isDetailsFetched) {
            getDetails(userProfile?.docid);
        }
    }

    const refreshAttachments = async () => {
        let GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
        let GetDetailData = JSON.parse(GetDetailDataString);

        if (GetDetailData != null) {
            const getUrl = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].getAttachment}`;
            const body = {
                "Proof_Type": GetDetailData.jobdetails.ProofType,
                "JobGUID": GetDetailData.jobdetails.JobGUID,
                "docid": userProfile.docid
            };
            try {
                const response = await axios.post(getUrl, body);
                let dataChange = response.data.data.map((item) => ({
                    ...item,
                    filetype: item.Filename.split('.')[1],
                }));
                let fileFilter = dataChange.filter(item => item.AttachType !== "gallery");
                setItemFile(fileFilter);
                setAttachmentContent(fileFilter);
            } catch (error) {
                console.log(error);
                toastError(error.message);
            }
        }
    };

    // const getDetails = (docId) => {
    //     let GetDetailDataString = localStorage.getItem(`${docId}_init-getdetails`);
    //     let GetDetailData = JSON.parse(GetDetailDataString);
    //     if (GetDetailData != null) {
    //         const getUrl = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].getAttachment}`;
    //         const body = {
    //             "Proof_Type": GetDetailData.jobdetails.ProofType,
    //             "JobGUID": GetDetailData.jobdetails.JobGUID,
    //             "docid": docId
    //         }
    //         axios.post(getUrl, body).then((response) => {
    //             let dataChange = response.data.data.map((item) => {
    //                 return {
    //                     ...item,
    //                     filetype: item.Filename.split('.')[1],
    //                 }
    //             }
    //             )
    //             let fileFilter = dataChange.filter(item => item.AttachType !== "gallery")
    //             setItemFile(fileFilter);
    //         }
    //         ).catch((error) => {
    //             console.log(error)
    //             toastError(error.message);
    //             // navigate(`/notification?docid=${docId}`, { state: 'error' })
    //         })
    //     }
    // }
    const getDetails = async (docId, forceUpdate = false) => {
        // If data exists and no force update, return
        if (itemFile.length > 0 && !forceUpdate) {
            return;
        }

        let GetDetailDataString = localStorage.getItem(`${docId}_init-getdetails`);
        let GetDetailData = JSON.parse(GetDetailDataString);

        if (GetDetailData != null) {
            const getUrl = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].getAttachment}`;
            const body = {
                "Proof_Type": GetDetailData.jobdetails.ProofType,
                "JobGUID": GetDetailData.jobdetails.JobGUID,
                "docid": docId
            };
            try {
                const response = await axios.post(getUrl, body);
                let dataChange = response.data.data.map((item) => ({
                    ...item,
                    filetype: item.Filename.split('.')[1],
                }));
                let fileFilter = dataChange.filter(item => item.AttachType !== "gallery");
                setItemFile(fileFilter);
                setAttachmentContent(fileFilter);
                setIsDetailsFetched(true);
            } catch (error) {
                console.log(error);
                toastError(error.message);
            }
        }
    };


    const handleFilterChange = (event) => {
        const { name, checked } = event.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: checked
        }));
        setTimeout(() => {
            if (name === "Warning") {
                if (filters.Warning === false) {
                    let warningFilter = errorCompileFullData.filter((item) => item.type === 'Warning')
                    // console.log(warningFilter, 'warningFilter')
                    setErrorCompile([...errorCompile, ...warningFilter])
                } else if (filters.Warning) {
                    if (filters.Error === false) {
                        setErrorCompile([])
                    } else {
                        let warningFilter = errorCompileFullData.filter((item) => item.type !== 'Warning')
                        setErrorCompile(warningFilter)
                    }
                }
            } else if (name === "Error") {
                if (filters.Error === false) {
                    let warningFilter = errorCompileFullData.filter((item) => item.type === 'Error')
                    setErrorCompile([...errorCompile, ...warningFilter])
                } else if (filters.Error) {
                    let warningFilter = errorCompile.filter((item) => item.type !== 'Error')
                    setErrorCompile(warningFilter)
                }
            }
        }, 100);
    };

    const styleEditingError = (value) => {
        if (value.error === true) {
            toastError(`${value.message}`)
        }
        else if (value.responseData.is_success === "false") {
            toastError('Api error')
        }
        else {
            if (value.errorObjects.length !== 0) {
                setErrorCompile(value.errorObjects)
                setErrorShow(true)
                if (value.responseData.is_error_status === "true") {
                    toastError('Macro api successfully completed with error.')
                }
                else if (value.responseData.is_error_status === "false" && value.responseData.is_warning_status === "true") {
                    toastWarning('Macro api successfully completed with warning.')
                    if (value.textcontent.length !== 0) {
                        setEditorStyle(value.textcontent)
                    }
                }
            }
            else if (value.responseData.is_error_status === "false" && value.responseData.is_warning_status === "false") {
                if (value.textcontent.length !== 0) {
                    setEditorStyle(value.textcontent)
                    toastSuccess('Macro api successfully completed.')
                }
            }
        }
    }

    const issueUpdationError = (value) => {
        if (value.error === true) {
            toastError(`${value.message}`)
        }
        else if (value.responseData.is_success === "false") {
            toastError('Api error')
        }
        else {
            if (value.errorObjects.length !== 0) {
                setErrorCompile(value.errorObjects)
                setErrorShow(true)
                if (value.responseData.is_error_status === "true") {
                    toastError('Issue Updation api successfully completed with error.')
                }
                else if (value.responseData.is_error_status === "false" && value.responseData.is_warning_status === "true") {
                    toastWarning('Issue Updation api successfully completed with warning.')
                    if (value.textcontent.length !== 0) {
                        setEditorStyle(value.textcontent)
                    }
                }
            }
            else if (value.responseData.is_error_status === "false" && value.responseData.is_warning_status === "false") {
                if (value.textcontent.length !== 0) {
                    setEditorStyle(value.textcontent)
                    toastSuccess('Issue Updation api successfully completed.')
                }
            }
        }
    }

    const XMPCreationError = (value) => {
        if (value.error === true) {
            toastError(`${value.message}`)
        }
        else if (value.responseData.is_success === "false") {
            toastError('Api error')
        }
        else {
            if (value.errorObjects.length !== 0) {
                setErrorCompile(value.errorObjects)
                setErrorShow(true)
                if (value.responseData.is_error_status === "true") {
                    toastError('XMPCreation api successfully completed with error.')
                }

            }
            else if (value.responseData.is_error_status === "false" && value.responseData.is_warning_status === "false") {
                toastSuccess('XMPCreation api successfully completed.')
            }
        }
    }

    const crossRefProgress = (value) => {
        if (value.error === true) {
            toastError(`${value.message}`)
        }
        else if (value.responseData.is_success === "false") {
            toastError('Api error')
        }
        else {
            if (value.errorObjects.length !== 0) {
                setErrorCompile(value.errorObjects)
                setErrorShow(true)
                if (value.responseData.is_error_status === "true") {
                    toastError('crossRef Updation api successfully completed with error.')
                }
                else if (value.responseData.is_error_status === "false" && value.responseData.is_warning_status === "true") {
                    toastWarning('crossRef Updation api successfully completed with warning.')
                    if (value.textcontent.length !== 0) {
                        setEditorStyle(value.textcontent)
                    }
                }
            }
            else if (value.responseData.is_error_status === "false" && value.responseData.is_warning_status === "false") {
                if (value.textcontent.length !== 0) {
                    setEditorStyle(value.textcontent)
                    toastSuccess('crossRef Updation api successfully completed.')
                }
            }
        }
    }


    const refrenceStrucutre = (data) => {
        if (data.error === true) {
            toastError(`${data.api}-${data.message}`)
        } else {
            if (data.errorObjects.length !== 0) {
                setErrorCompile(data.errorObjects)
                setErrorShow(true);
                setErrorTab('errorlog');
                if (data.responseData.is_error_status === "true") {
                    toastError(`${data.api} - api successfully completed with error.`)
                }
                else if (data.responseData.is_error_status === "false" && data.responseData.is_warning_status === "true") {
                    toastWarning('Reference ordering api successfully completed with warning.')
                    if (data.texcontent.length !== 0) {
                        setEditorStyle(data.texcontent)
                    }
                }
            }
            else if (data.responseData.is_error_status === "false" && data.responseData.is_warning_status === "false") {
                if (data.texcontent.length !== 0) {
                    setEditorStyle(data.texcontent)
                    toastSuccess('Reference ordering api successfully completed.')
                }
            }
        }
    }

    const MacroCleanUp = (data) => {
        if (data.error === true) {
            toastError(`${data.message}`)
        } else {
            if (data.errorObjects.length !== 0) {
                setErrorCompile(data.errorObjects)
                setErrorShow(true);
                setErrorTab('errorlog');
                if (data.responseData.is_error_status === "true") {
                    setMicroSave(false);
                    toastError('Macro api successfully completed with error.')
                }
                else if (data.responseData.is_error_status === "false" && data.responseData.is_warning_status === "true") {
                    setMicroSave(true);
                    toastWarning('Macro api successfully completed with warning.')
                    if (data.textcontent.length !== 0) {
                        setEditorStyle(data.textcontent)
                    }
                }
            } else if (data.responseData.is_error_status === "false" && data.responseData.is_warning_status === "false") {
                if (data.textcontent.length !== 0) {
                    setEditorStyle(data.textcontent)
                    toastSuccess('Macro api successfully completed.')
                    setMicroSave(true);
                }
            }
        }
    }

    const iRefProgress = (data) => {
        if (data.error === true) {
            toastError(`${data.message}`)
        } else {
            if (data.errorObjects.length !== 0) {
                setErrorCompile(data.errorObjects)
                setErrorShow(true);
                setErrorTab('errorlog');
                if (data.responseData.is_error_status === "true") {
                    // setMicroSave(false);
                    toastError('iRef api successfully completed with error.')
                }
                else if (data.responseData.is_error_status === "false" && data.responseData.is_warning_status === "true") {
                    setMicroSave(true);
                    toastWarning('iRef api successfully completed with warning.')
                    if (data.textcontent.length !== 0) {
                        setEditorStyle(data.textcontent)
                    }
                }
            } else if (data.responseData.is_error_status === "false" && data.responseData.is_warning_status === "false") {
                if (data.textcontent.length !== 0) {
                    setEditorStyle(data.textcontent)
                    toastSuccess('iRef api successfully completed.');
                    setMicroSave(true);
                }
            }
        }
    }

    const downloadIrefJson = async () => {
        const GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
        const GetDetailData = JSON.parse(GetDetailDataString);
        const outputPath = GetDetailData?.Articledetails?.OutputPath;
        const basePath = outputPath.substring(0, outputPath.lastIndexOf("/"));
        const irefJsonPath = `${basePath}/Input.json`;
        try {
            // First check if file exists
            const checkResponse = await axios.post(
                `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].blobFileExistorNot}`,
                { InputPath: irefJsonPath }
            );

            // Only proceed with download if file exists
            if (!checkResponse.data.exist) {
                toastError('iRef JSON file not found in the blob storage');
                return;
            }

            // File exists, proceed with download
            const response = await axios.post(
                `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].download}`,
                {
                    blobUrl: irefJsonPath,
                    type: 'application/json'
                },
                {
                    responseType: 'blob'
                }
            );

            // Create and trigger download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Input.json');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            toastSuccess('iRef JSON downloaded successfully');
        } catch (error) {
            toastError('Failed to download iRef JSON');
        }
    };

    const handleToggle = () => {
        setToggleLayout(!toggleLayout)
    };

    const handleClickOutside = (event) => {
        if (toggleRef.current && !toggleRef.current.contains(event.target)) {
            setToggleLayout(false);
        }
    };

    const validateAltTextVerification = () => {
  if (!alttextEnabled) return true;
  if (!altTextContent) return true;

  // Master Copier: every Create/Validate image must have a non-empty comment
  // and the "Validated by MC" checkbox checked before submitting. Surface any
  // issues in the Validation tab (clickable -> opens that image).
  if (userProfile?.role === "Master Copier") {
    const issues = [];
    Object.entries(altTextContent).forEach(([fileName, data]) => {
      const action = data?.actionBtn;
      if (action !== "validate" && action !== "create") return;

      // Comment is mandatory only for the "create" action. For "validate" the
      // Master Copier is confirming existing alt text, so a comment is optional.
      const commentMissing =
        action === "create" &&
        (!data?.comment || String(data.comment).trim() === "");
      const notValidated = !data?.mcValidated;
      if (!commentMissing && !notValidated) return;

      const cleanName = fileName.replace(/\.pdf$/i, "");
      const missing = [];
      if (commentMissing) missing.push("a comment");
      if (notValidated) missing.push('"Validated by MC" confirmation');

      issues.push({
        message: `${cleanName}: Please add ${missing.join(" and ")} for the "${action}" action.`,
        position: "Image",
        fileName,
      });
    });

    if (issues.length) {
      validation(issues.map((it, i) => ({ ...it, serial: i + 1 })));
      return false;
    }
    // No issues — clear any stale validation rows.
    validation([]);
    return true;
  }

  // Client-requested removal (kept commented, not deleted, in case this needs
  // to come back): Author-side unverified-images block, tied to the same
  // "Verified the Alt Text" checkbox commented out in imagelist.js.
  // const unverifiedImages = Object.entries(altTextContent)
  //   .filter(([, data]) => data?.short && data?.long && !data?.verified)
  //   .map(([fileName]) => fileName);

  // if (unverifiedImages.length) {
  //   toastError("Please verify all images before submitting.");
  //   return false;
  // }

  return true;
};

    const downloadTrackPdf = async () => {
        setShowprogress(true);
        setDownloadTrackFile(true)
        try {
            let TrackContent = await TrackChangeTagforDownload();
            TrackContent = TrackContent.replace(
                /\\documentclass\[([^\]]*)\]\{([^\}]*)\}/,
                (match, options, className) => {
                    // Convert options to an array, add "trackchanges" if not already present
                    const optionsArray = options.split(',').map(opt => opt.trim());
                    if (!optionsArray.includes('trackchanges')) {
                        optionsArray.push('trackchanges');
                    }
                    const newOptions = optionsArray.join(',');
                    return `\\documentclass[${newOptions}]{${className}}`;
                }
            );
            console.log(TrackContent, 'updatedStr')
            let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].downloadTrackchanges}`;
            const data = {
                filename: userProfile.docid,
                data: TrackContent
            }
            const response = await axios.post(url, data);
            if (response.data.status === 'success') {
                const byteCharacters = atob(response.data.pdfBase64);
                const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
                const byteArray = new Uint8Array(byteNumbers);
                // Create a Blob from the binary data
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                // Create a temporary anchor tag
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${fullData.Filename}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setShowprogress(false);
                setDownloadTrackFile(false);
            }
        } catch (error) {
            console.error("Error while downloading track PDF:", error);
            toastError("Error while downloading track PDF");
            setShowprogress(false);
            setDownloadTrackFile(false);
        }
    };

    const TrackChangeTagforDownload = () => {
        try {
            let latexContent = editorContent.length !== 0 ? editorContent : fileContentData;

            let ranges = trackChanges || [];
            // Sort the ranges in reverse order of their positions to handle replacements correctly
            let sortedRanges = ranges.sort((a, b) => {
                if (a.from === b.from) {
                    return b.to - a.to;
                }
                return b.from - a.from;
            });
            // Helper function to format content for \ins and \del
            const insertText = (originalText, range, type) => {
                let before = originalText.slice(0, range.from);
                let after = originalText.slice(range.to);
                if (type === 'del') {
                    return before + `\\del{${range.decoration.spec.text}}` + after;
                } else if (type === 'ins') {
                    return before + `\\ins{${range.text}}` + after;
                }
                return originalText; // Fallback to avoid unexpected behavior
            };
            // Iterate over the sorted ranges and update the content
            for (let range of sortedRanges) {
                if (range.type === 'deletion') {
                    latexContent = insertText(latexContent, range, 'del');
                } else if (range.type === 'insertion') {
                    latexContent = insertText(latexContent, range, 'ins');
                }
            }
            return latexContent;
        } catch (error) {
            throw new Error(`TrackChange Tag for Download error - ${error.message}`);
        }
    }

    const downloadTrackChangePDF = async () => {
        setShowprogress(true);
        setDownloadTrackFile(true)
        try {

            let GetDetailDataString = localStorage.getItem(`${userProfile.docid}_init-getdetails`);
            var GetDetailData = JSON.parse(GetDetailDataString);
            let OutputPath = GetDetailData.Articledetails.OutputPath;
            // Conditionally replace "128" with "83" for Master Copier
            if (userProfile.role === "Master Copier") {
                OutputPath = OutputPath.replace('/128/', '/83/');
            }
            let InputPath = OutputPath.replace("/Output/", "/Input/").replace(".xml", ".tex");
            let blobDomain = GetDetailData.Articledetails.blobDomain;
            let InputFileBlobPath = `${blobDomain}${InputPath}`;
            // 'ActivityID': GetDetailData.ActivtyDetails.ActivityID,
            // 'Proof_Type': GetDetailData.jobdetails.ProofType,
            let Role = userProfile.role
            let latexContent = editorContent.length !== 0 ? editorContent : fileContentData;
            let TrackContent = latexContent;

            console.log(TrackContent, 'updatedStr')
            let url = `${pathconfig[packjson.environment].baseUrl}${pathconfig[packjson.environment].downloadTrackPDF}`;
            const data = {
                InputFileBlobPath: InputFileBlobPath,
                Role: Role,
                filename: userProfile.docid,
                data: TrackContent
            }
            const response = await axios.post(url, data);
            if (userProfile.role === "Author") {
                let logContent = atob(response.data.logBase64);
                let checkText = 'LaTeX Warning: There were undefined references';
                if (logContent.includes(checkText)) {
                    setProgressDetails('Uncited Element Found. Please wait, Re-compilation in progress...');
                    setShowprogress(true); // 👈 Show progress before retry
                    await downloadTrackChangePDF(); // 🔁 Retry
                    setShowprogress(false); // 👈 Hide progress after retry
                    return; // 🔒 Prevent further execution (and avoid extra download)
                }
            }

            if (response.data.status === 'success') {
                const byteCharacters = atob(response.data.pdfBase64);
                const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
                const byteArray = new Uint8Array(byteNumbers);
                // Create a Blob from the binary data
                const blob = new Blob([byteArray], { type: 'application/pdf' });
                // Create a temporary anchor tag
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${fullData.Filename}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setShowprogress(false);
                setDownloadTrackFile(false);
            }
        } catch (error) {
            console.error("Error while downloading track PDF:", error);
            toastError("Error while downloading track PDF");
            setShowprogress(false);
            setDownloadTrackFile(false);
        }
    };
    const handleDownloadKeyDown = (e) => {
        // Check if Enter key is pressed
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault(); // Prevent default browser behavior
            downloadTrackChangePDF(e); // Call your main function
        }
    };

    const TrackChangesFiledownload = async () => {
        setShowprogress(true);
        setDownloadTrackFile(true)
        try {
            let TrackContent = await TrackChangeTagforDownload();
            TrackContent = TrackContent.replace(
                /\\documentclass\[([^\]]*)\]\{([^\}]*)\}/,
                (match, options, className) => {
                    // Convert options to an array, add "trackchanges" if not already present
                    const optionsArray = options.split(',').map(opt => opt.trim());
                    if (!optionsArray.includes('trackchanges')) {
                        optionsArray.push('trackchanges');
                    }
                    const newOptions = optionsArray.join(',');
                    return `\\documentclass[${newOptions}]{${className}}`;
                }
            );
            console.log(TrackContent, 'updatedStr')

            // Download TrackContent directly
            const blob = new Blob([TrackContent], { type: 'text/plain' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${fullData.Filename}_trackchanges.tex`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);

            setShowprogress(false);
            setDownloadTrackFile(false);

        } catch (error) {
            console.error("Error while downloading track content:", error);
            toastError("Error while downloading track content");
            setShowprogress(false);
            setDownloadTrackFile(false);
        }
    };


    // Added event listener for spell check settings and sync with F7/global changes
    useEffect(() => {
        const handleSpellCheckSettings = (event) => {
            if (event.detail.openSettings) {
                setShowOffcanvas(true);
            }
        };
        const handleSpellCheckSettingsChanged = (event) => {
            if (event && event.detail) {
                setSpellCheckSettings(prev => ({ ...prev, ...event.detail }));
                // Show toast when spell check is toggled
                if (typeof toastSuccess === 'function') {
                    if (event.detail.enabled) {
                        toastSuccess('Spell check enabled');
                    } else {
                        toastSuccess('Spell check disabled');
                    }
                }
            }
        };
        document.addEventListener('openSpellCheckSettings', handleSpellCheckSettings);
        document.addEventListener('spellCheckSettingsChanged', handleSpellCheckSettingsChanged);
        return () => {
            document.removeEventListener('openSpellCheckSettings', handleSpellCheckSettings);
            document.removeEventListener('spellCheckSettingsChanged', handleSpellCheckSettingsChanged);
        };
    }, []);


    // Focus Log tab when errorShow is triggered (from sidebar)
    useEffect(() => {
        if (errorShow && logTabBtnRef.current) {
            logTabBtnRef.current.focus();
        }
    }, [errorShow]);

    useEffect(() => {
        if (!alttextEnabled) return;
        setAltTextClickHandler((fileName) => {
            setSidebar('leftbar');
            setLeftsidebarvalue('image');
            setSidebarClose(false);
            if (fileName) {
                // Add .pdf if extension is missing
                if (fileName && !/\.[a-zA-Z0-9]+$/.test(fileName)) {
                fileName += ".pdf";
                }
                setImageToHighlight(fileName);
            }
        });
        return () => {
            setAltTextClickHandler(null);
        };
    }, [alttextEnabled]);

    // fallback for instances where the editor dispatches the DOM event directly
    useEffect(() => {
        if (!alttextEnabled) return;
        const handleAltTextClick = (e) => {
            const fileName = e.detail && e.detail.fileName;
            setSidebar('leftbar');
            setLeftsidebarvalue('image');
            setSidebarClose(false);
            if (fileName) setImageToHighlight(fileName);
        };
        document.addEventListener('alttext:clicked', handleAltTextClick);
        return () => document.removeEventListener('alttext:clicked', handleAltTextClick);
    }, [alttextEnabled]);

    return (
        <>
            <ul className="skip-links-menu">
                <li>
                    <a
                        href="#main-content"
                        className="skip-link"
                        onClick={e => {
                            e.preventDefault();
                            const el = document.getElementById('main-content');
                            if (el) el.focus();
                        }}
                    >
                        Skip to main content
                    </a>
                </li>
                <li>
                    <a
                        href="#left-sidebar"
                        className="skip-link"
                        onClick={e => {
                            e.preventDefault();
                            const el = document.getElementById('left-sidebar');
                            if (el) el.focus();
                        }}
                    >
                        Skip to left sidebar
                    </a>
                </li>
                <li>
                    <a
                        href="#right-sidebar"
                        className="skip-link"
                        onClick={e => {
                            e.preventDefault();
                            const el = document.getElementById('right-sidebar');
                            if (el) el.focus();
                        }}
                    >
                        Skip to right sidebar
                    </a>
                </li>
            </ul>
            <div className={`modal-outer ${showProgress ? 'active' : ''}`}>
                <div className="modal confirmation-popup">
                    <div className="modal-header">
                        <h1>Please Wait</h1>
                    </div>
                    <div className="modal-body">
                        <p>{dowloadTrackFile ? progressDetails : "Support file download."}</p>
                        <span className="loader"></span>
                    </div>
                </div>
            </div>
            {loader || !isAttachmentLoaded ? (
                <div className="loader-outer">
                    <img
                        src={Loader}
                        alt="loader"
                        style={{ width: "50px", marginBottom: "16px" }}
                    />
                    <span className="loader"></span>
                </div>
            ) : (
                <div className={readOnly ? "readEditor" : ""}>
                    <div aria-live="polite" aria-atomic="true" className="sr-only" style={{ position: 'absolute', left: '-10000px', width: '1px', height: '1px', overflow: 'hidden' }}>{announcement}</div>
                    <div className={`layout ${sidebar}`}>
                        <header aria-label="Application Header">
                            <div className="logo-side star-burst">
                                <img src={Logo} alt="logo" />
                                <h1>iAuthor</h1>
                            </div>
                            <div className="header-center">
                                <h1>{fullData.Filename} {articleStatus ? "- The Article is submitted, The link is now in Read-only mode, you cannot edit or update." : ""}</h1>
                            </div>
                            <div className="header-right-side">
                                {/* Button to show initial TeX, can be conditionally rendered as needed */}
                                {articleStatus && ActivityName && (ActivityName.includes('L2') || ActivityName.includes('L2QA')) && (
                                    <button className="help-btn" onClick={() => editorImperativeRef.current?.showInitialTex()}>
                                        <AiOutlineHistory /> {editorImperativeRef.current?.isShowingInitialTex && editorImperativeRef.current.isShowingInitialTex() ? "Show Current TeX" : "Show Initial TeX"}
                                    </button>
                                )}
                                <button
                                    className="help-btn"
                                    onClick={() => { props.handleHelp(true); setAnnouncement('Help button clicked') }}
                                >
                                    <MdHelpOutline /> Help
                                </button>
                                <div className="layout-dropdown-area">
                                    <button className="help-btn layout-btn" onClick={handleToggle}><FaColumns /> Layout</button>
                                    {toggleLayout ? <div className="layout-dropdown" ref={toggleRef}>
                                        <ul>
                                            <li><button onClick={() => { layoutOption('editorandpdf'); setAnnouncement('editorandpdf button clicked') }} className={layout === 'editorandpdf' ? 'active' : ''}><FaColumns /> Editor & Pdf </button></li>
                                            <li><button onClick={() => { layoutOption('editoronly'); setAnnouncement('editoronly button clicked') }} className={layout === 'editoronly' ? 'active' : ''}><FaCode /> Editor only</button></li>
                                            <li><button onClick={() => { layoutOption('pdfonly'); setAnnouncement('pdfonly button clicked') }} className={layout === 'pdfonly' ? 'active' : ''}><FaRegFilePdf /> Pdf only</button></li>
                                        </ul>
                                    </div> : ''}
                                </div>
                                <section className="profile-details" aria-label="User Profile">
                                    <div>
                                        <FaRegUserCircle />{" "}
                                    </div>
                                    <div>
                                        <h2>{userProfile.username}</h2>
                                        <span>{userProfile.role}</span>
                                    </div>
                                </section>
                            </div>
                        </header>
                        <div className="layout-inner">
                            <div id="left-sidebar" tabIndex="-1" className="left-panel">
                                <div>
                                    <ul className="tools-list">
                                        {fullData ? (
                                            ""
                                        ) : (
                                            <li>
                                                <button
                                                    onClick={() =>
                                                        slidebarHandle("leftbar", "fileview")
                                                    }
                                                    className={
                                                        leftsidebarvalue === "fileview" ? "active" : ""
                                                    }
                                                    title="File"
                                                >
                                                    <FaRegFile />
                                                </button>
                                            </li>
                                        )}
                                        {/* <li>
                                        <button title="New Folder">
                                            <FaFolder />
                                        </button>
                                    </li> */}
                                        <li>
                                            <button
                                                title="Attachement Tab"
                                                onClick={() =>
                                                    slidebarHandle("leftbar", "attachement")
                                                }
                                                className={
                                                    leftsidebarvalue === "attachement"
                                                        ? "active attachement-btn sixthstep"
                                                        : "attachement-btn sixthstep"
                                                }
                                            >
                                                <span>{itemFile.length}</span>
                                                <FaPaperclip />
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                id="toc-tab-btn"
                                                title="Table of content Tab"
                                                onClick={() => slidebarHandle("leftbar", "toc")}
                                                className={leftsidebarvalue === "toc" ? "active" : ""}                                    >
                                                <FaList />
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                id="history-tab-btn"
                                                onClick={() => slidebarHandle("leftbar", "history")}
                                                className={
                                                    leftsidebarvalue === "history"
                                                        ? "active ninthstep"
                                                        : "ninthstep"
                                                }
                                                title="History Tab"
                                            >
                                                <FaHistory />
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                id="image-tab-btn"
                                                onClick={() => slidebarHandle("leftbar", "image")}
                                                className={
                                                    leftsidebarvalue === "image"
                                                        ? "active eigthstep"
                                                        : "eigthstep"
                                                }
                                                title="Image Tab"
                                            >
                                                <FaImage />
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                id="supplementary-tab-btn"
                                                onClick={() =>
                                                    slidebarHandle("leftbar", "supplementary")
                                                }
                                                className={
                                                    leftsidebarvalue === "supplementary"
                                                        ? "active seventhstep"
                                                        : "seventhstep"
                                                }
                                                title="Supplementary Tab"
                                            >
                                                <FaFileInvoice />
                                            </button>
                                        </li>
                                        {/* {userProfile && (userProfile.role === "Author") && (
                                        <li>
                                            <button
                                                id="video-tab-btn"
                                                onClick={() =>
                                                    slidebarHandle("leftbar", "video")
                                                }
                                                className={
                                                    leftsidebarvalue === "video"
                                                        ? "active video-btn"
                                                        : "video-btn"
                                                }
                                                title="Video Tab"
                                            >
                                                <FaVideo />
                                            </button>
                                        </li>
                                        )} */}
                                    </ul>
                                    <button
                                        className="theme-btn"
                                        onClick={() => { setShowOffcanvas(true); setAnnouncement('Settings button clicked') }}
                                        aria-label="Open settings"
                                        title="Settings"
                                    >
                                        <FaCog aria-hidden="true" />
                                    </button>
                                </div>
                                <div className={`left-sidebar ${leftsidebarvalue}`}>
                                    {/* <FilelistTab close={leftbarClose} editorData={editorData} /> */}
                                    <TocTab leftsidebarvalue={leftsidebarvalue} />
                                    <AttachementTab
                                        fileItems={itemFile}
                                        getTrigger={getTrigger}
                                        refreshAttachments={refreshAttachments}
                                        leftsidebarvalue={leftsidebarvalue}
                                    />
                                    <HistoryTab
                                        leftsidebarvalue={leftsidebarvalue}
                                        reloadData={reloadData}
                                        fileReload={fileProgess}
                                    />
                                    <ImagelistTab
                                        leftsidebarvalue={leftsidebarvalue}
                                        getTrigger={getTrigger}
                                        altTextContent={altTextContent}
                                        setAltTextContent={setAltTextContent}
                                        highlightFile={imageToHighlight}
                                        onHighlightDone={() => setImageToHighlight(null)}
                                        fileItems={itemFile}
                                    />
                                    <SupplementaryTab
                                        leftsidebarvalue={leftsidebarvalue}
                                        supplementComments={supplementComments}
                                        fileItems={itemFile}
                                    />
                                    {alttextEnabled && <VideoTab leftsidebarvalue={leftsidebarvalue} />}
                                </div>
                            </div>
                            <div id="main-content" tabIndex="-1" className={`center-panel-group ${errorShow ? 'error-active' : ''} 
                        ${closeErrorLog ? 'lineFocus' : ''}`}>
                                <div className="center-panel-group-inner">
                                    <Split
                                        className={`center-panel ${layout}`}
                                        onDragEnd={handleDragEnd}
                                    >
                                        <div className="center-panel-inner">
                                            <CodeMirrorEditor
                                                ref={editorImperativeRef}
                                                menuTrigger={dragTrigger}
                                                fontSize={settingGroup[2].value}
                                                textWrap={settingGroup[3].value}
                                                styleEditingError={styleEditingError}
                                                issueUpdationError={issueUpdationError}
                                                XMPCreationError={XMPCreationError}
                                                crossRefProgress={crossRefProgress}
                                                refrenceStrucutre={refrenceStrucutre}
                                                MacroCleanUp={MacroCleanUp}
                                                iRefProgress={iRefProgress}
                                            />
                                        </div>
                                        <div tabIndex="-1" className="center-panel-inner">
                                            <PdfEditor
                                                ref={pdfEditorRef}
                                                compileError={compileError}
                                                fileSave={fileSave}
                                                downloadTrigger={downloadTrigger}
                                                fileSaveStatus={fileSaveStatus}
                                                LogDataFile={LogDataFile}
                                                validation={validation}
                                                fileItems={itemFile}
                                                closeErrorOnCompile={closeErrorOnCompile}
                                                altTextContent={altTextContent}
                                                validateAltTextVerification={validateAltTextVerification}
                                                setSidebar={setSidebar}
                                                setLeftsidebarvalue={setLeftsidebarvalue}
                                                setSidebarClose={setSidebarClose}
                                            />
                                        </div>
                                    </Split>
                                    <div className="error-split-panel">
                                        <div className="error-split-header">
                                            <div>
                                                <button
                                                    className={errorTab === "log" ? "active" : ""}
                                                    onClick={() => logTab("log")}
                                                    tabIndex={0}
                                                    ref={logTabBtnRef}
                                                >
                                                    Log
                                                </button>
                                                <button
                                                    className={errorTab === "errorlog" ? "active" : ""}
                                                    onClick={() => logTab("errorlog")}
                                                    tabIndex={0}
                                                >
                                                    Error log
                                                </button>

                                                <button
                                                    className={
                                                        errorTab === "validation" ? "active" : ""
                                                    }
                                                    onClick={() => logTab("validation")}
                                                    tabIndex={0}
                                                >
                                                    Validation
                                                </button>
                                            </div>
                                            <button
                                                title="Close"
                                                className="close"
                                                onClick={() => {
                                                    setErrorShow(!errorShow);
                                                    setTimeout(() => {
                                                        // Focus the Log files Tab button in the sidebar
                                                        const logFilesTabBtn = document.querySelector('button[title="Log files Tab"]');
                                                        if (logFilesTabBtn) logFilesTabBtn.focus();
                                                    }, 0);
                                                }}
                                                onKeyDown={e => {
                                                    if (e.key === 'Tab' && !e.shiftKey) {
                                                        e.preventDefault();
                                                        setTimeout(() => {
                                                            // Focus the Log files Tab button in the sidebar
                                                            const logFilesTabBtn = document.querySelector('button[title="Log files Tab"]');
                                                            if (logFilesTabBtn) logFilesTabBtn.focus();
                                                        }, 0);
                                                    }
                                                }}
                                            >
                                                <FaTimes />
                                            </button>
                                        </div>
                                        {errorTab === "errorlog" ? (
                                            <div className="error-body top-filter-added">
                                                <div className="error-filter">
                                                    <div className="error-filter-inner error">
                                                        <input
                                                            type="checkbox"
                                                            id="error"
                                                            name="Error"
                                                            checked={filters.Error}
                                                            value="Error"
                                                            onChange={handleFilterChange}
                                                        />
                                                        <label htmlFor="error">
                                                            <FaTimesCircle /> Error
                                                        </label>
                                                    </div>
                                                    <div className="error-filter-inner warning">
                                                        <input
                                                            type="checkbox"
                                                            id="warning"
                                                            name="Warning"
                                                            checked={filters.Warning}
                                                            value="Warning"
                                                            onChange={handleFilterChange}
                                                        />
                                                        <label htmlFor="warning">
                                                            <FaExclamationTriangle /> Warning
                                                        </label>
                                                    </div>
                                                </div>
                                                {errorCompile.length > 0 ? (
                                                    <div className="tbl-fixed">
                                                        <Table responsive>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ minWidth: "30px" }}></th>
                                                                    <th style={{ minWidth: "100px" }} aria-label="line number" tabIndex={0}>
                                                                        Line Number
                                                                    </th>
                                                                    <th style={{ minWidth: "100px" }} aria-label="error or warning type" tabIndex={0}>Type</th>
                                                                    <th aria-label="description" tabIndex={0}>Description</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {[...errorCompile]
                                                                    .sort((a, b) => {
                                                                        // First sort by type: Error comes first
                                                                        if (a.type === "Error" && b.type !== "Error") return -1;
                                                                        if (a.type !== "Error" && b.type === "Error") return 1;
                                                                        // Then sort by line number for same types
                                                                        return a.line - b.line;
                                                                    })
                                                                    .map((item, index) => (
                                                                        <tr
                                                                            key={index}
                                                                            className={item.type}
                                                                            onClick={() => errorFocus(item)}
                                                                        >
                                                                            <td>
                                                                                {item.type === "Error" ? (
                                                                                    <FaTimesCircle />
                                                                                ) : item.type === "Warning" ? (
                                                                                    <FaExclamationTriangle />
                                                                                ) : (
                                                                                    ""
                                                                                )}
                                                                            </td>
                                                                            <td aria-label={`${item.line}`} tabIndex={0}>{item.line}</td>
                                                                            <td aria-label={`${item.type}`} tabIndex={0}>{item.type} </td>
                                                                            <td aria-label={`${item.message}`} tabIndex={0}>{item.message}</td>
                                                                        </tr>
                                                                    ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                ) : (
                                                    <div className="no-data-center">
                                                        <p>No error log</p>
                                                    </div>
                                                )}
                                            </div>
                                        ) : errorTab === "log" ? (
                                            <div className="error-body">
                                                {logFile ? (
                                                    <div className="log-pre-area">
                                                        <pre>{logFile}</pre>
                                                    </div>
                                                ) : (
                                                    <div className="no-data-center">
                                                        <p>No log files</p>
                                                    </div>
                                                )}
                                            </div>
                                        ) : errorTab === "validation" ? (
                                            <div className="error-body">
                                                {validationdata ? (
                                                    <div className="tbl-fixed" role="region" aria-live="polite" aria-label="Validation Errors Table">
                                                        <section>
                                                            <Table responsive>
                                                                <thead>
                                                                    <tr role="row">
                                                                        <th style={{ width: "60px" }} aria-label="serial number" tabIndex={0}>S.no</th>
                                                                        <th style={{ minWidth: "80px" }} aria-label="Validation message" tabIndex={0}>Message</th>
                                                                        <th style={{ minWidth: "20px" }} aria-label="line number" tabIndex={0}>Position</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {validationdata.map((item, index) => (
                                                                        <tr role="row" key={index}
                                                                            onClick={() => {
                                                                                if (item.position === "Image") {
                                                                                    errorFocus(item);
                                                                                }
                                                                            }}
                                                                        >
                                                                            <td role="cell" aria-label={`${item.serial}`} tabIndex={0}>{item.serial}</td>
                                                                            <td role="cell" aria-label={`${item.message}`} tabIndex={0}>{item.message} </td>
                                                                            <td role="cell" aria-label={`${item.position}`} >
                                                                                {" "}
                                                                                {item.position === "Query" ? (
                                                                                    item.position
                                                                                ) : (
                                                                                    <button
                                                                                        onClick={() => errorFocus(item)}
                                                                                    >
                                                                                        {item.position}
                                                                                    </button>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </section>
                                                    </div>
                                                ) : (
                                                    <div className="no-data-center">
                                                        <p>No validation</p>
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>
                                <footer className="center-panel-bottom" role="contentinfo" aria-label="Editor footer">
                                    <div className="center-panel-bottom-inner"></div>
                                    <div className="center-panel-bottom-inner middle">
                                        Powered by <img src={integraLogo} alt="integra logo" /> |
                                        All Rights Reserved
                                    </div>
                                    <div className="center-panel-bottom-inner">
                                        {logStatus ? (
                                            <p className="lock-text">
                                                <FaLock /> Article locked by someone.
                                            </p>
                                        ) : articleStatus ? (
                                            <p className="submit-text">
                                                The Article is submitted.
                                            </p>
                                        ) : ''}
                                        {fileProgess ? (
                                            <div className="saving-area">
                                                <p>
                                                    <label className="loader_saving"></label>Saving
                                                </p>
                                            </div>
                                        ) : filestatus ? (
                                            <div className="saving-area">
                                                <p>
                                                    Last saved on{" "}
                                                    {moment(lastsavedTime).format(
                                                        "DD MMMM YYYY - HH:mm:ss"
                                                    )}
                                                </p>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </footer>
                            </div>
                            <div id="right-sidebar" tabIndex="-1" className="right-panel">
                                <div className="right-panel-list">
                                    <ul>
                                        <li>
                                            <button
                                                onClick={() => rightBarHandle("rightbar", "query")}
                                                className={
                                                    rightsidebarvalue === "query"
                                                        ? "active thirdstep"
                                                        : "thirdstep"
                                                }
                                                title=" Author Query Tab"
                                            >
                                                <FaComment />
                                            </button>
                                        </li>
                                        {userProfile.role !== 'Master Copier' ? <li>
                                            <button
                                                id="comment-tab-btn"
                                                tabIndex={0}
                                                onClick={() => rightBarHandle("rightbar", "comment")}
                                                className={
                                                    rightsidebarvalue === "comment"
                                                        ? "active secondstep"
                                                        : "secondstep"
                                                }
                                                title="Comment Tab"
                                            >
                                                <FaComments />
                                            </button>
                                        </li> : ""}
                                        {!["L1 QA", "L1"].includes(ActivityName) ?
                                            <li className="submenu">
                                                <button
                                                    title="Download Trackchanges PDF"
                                                    //onClick={downloadFile}
                                                    onKeyDown={(e) => handleDownloadKeyDown(e)}
                                                    className="fourthstep"
                                                >
                                                    <FaDownload />
                                                </button>
                                                <ul className="submenu-right">
                                                    {userProfile.role === "Copy Editor" ? (
                                                        <li>
                                                            {/* old track pdf download */}
                                                            <button
                                                                title="Download PDF with trackchanges"
                                                                onClick={downloadTrackPdf}
                                                            >
                                                                Download TrackChange PDF
                                                            </button>
                                                        </li>
                                                    ) : (
                                                        <li>
                                                            <button
                                                                title="Download PDF with TrackChange"
                                                                onClick={downloadTrackChangePDF}
                                                                className="fourthstep"
                                                            >
                                                                Download PDF with TrackChange
                                                            </button>
                                                        </li>
                                                    )}
                                                </ul>
                                            </li> :
                                            <li>
                                                <button
                                                    title="Download trackachanges PDF"
                                                    onClick={downloadFile}
                                                    className="fourthstep"
                                                >
                                                    <FaDownload />
                                                </button>
                                            </li>}
                                        <li style={{ display: `${readOnly ? "none" : ""}` }}>
                                            <button
                                                title="Log files Tab"
                                                className={errorShow ? "active" : ""}
                                                onClick={errorLogShow}
                                            >
                                                <FaFileAlt />
                                            </button>
                                        </li>
                                        {!["Editor", "Author"].includes(userProfile.role) ? (
                                            <li>
                                                <button
                                                    title="Supporting Files"
                                                    onClick={downloadzipfolder}
                                                >
                                                    <FaFileArchive />
                                                </button>
                                            </li>
                                        ) : (
                                            ""
                                        )}
                                        {userProfile.role !== 'Master Copier' ? <li>
                                            <button
                                                title="Track Changes Tab"
                                                onClick={() =>
                                                    rightBarHandle("rightbar", "trackchanges")
                                                }
                                                className={
                                                    rightsidebarvalue === "trackchanges"
                                                        ? "active fifthstep"
                                                        : "fifthstep"
                                                }
                                            >
                                                <FaPencilAlt />
                                            </button>
                                        </li> :
                                            <li>
                                                <button
                                                    title="Track Changes and Comment tab"
                                                    onClick={() =>
                                                        rightBarHandle("rightbar", "tackandcomment")
                                                    }
                                                    className={
                                                        rightsidebarvalue === "tackandcomment"
                                                            ? "active fifthstep"
                                                            : "fifthstep"
                                                    }
                                                >
                                                    <BiSolidCommentEdit />
                                                </button>
                                            </li>}
                                        {userProfile.role === "Master Copier" && (
                                            <li>
                                                <button
                                                    title="TrackChangeFile.tex download"
                                                    onClick={TrackChangesFiledownload}
                                                    // onClick={downloadFile}
                                                    className="fourthstep"
                                                >
                                                    <IoMdCodeDownload style={{ fontSize: '22px' }} />
                                                </button>
                                            </li>
                                        )}
                                        {userProfile.role === "Technical Editor" && (
                                            <li>
                                                <button
                                                    title="iRef JSON Download"
                                                    onClick={downloadIrefJson}
                                                    className={
                                                        rightsidebarvalue === "trackchanges"
                                                            ? "active fifthstep"
                                                            : "fifthstep"
                                                    }
                                                >
                                                    <BiSolidFileJson />
                                                </button>
                                            </li>
                                        )}
                                        {userProfile.role === "Copy Editor" && (
                                            <>
                                                <li>
                                                    <button
                                                        title="INLP Suggestions"
                                                        onClick={() => rightBarHandle("rightbar", "inlp")}
                                                        className={rightsidebarvalue === "inlp" ? "active" : ""}
                                                    >
                                                        <FaSpellCheck />
                                                        {inlpActions?.length > 0 && (
                                                            <span className="badge" style={{ fontSize: '8px' }}>{inlpActions.length}</span>
                                                        )}
                                                    </button>
                                                </li>

                                            </>
                                        )}
                                    </ul>
                                </div>
                                <div className="right-sidebar">
                                    {rightsidebarvalue === "query" ? (
                                        <AuthorQueryTab
                                            getTrigger={getTrigger}
                                            refreshAttachments={refreshAttachments}
                                        />
                                    ) : rightsidebarvalue === "comment" ? (
                                        <CommentTab
                                            getTrigger={getTrigger}
                                            refreshAttachments={refreshAttachments}
                                        />
                                    ) : rightsidebarvalue === "trackchanges" ? (
                                        <TrackChanges />
                                    ) : rightsidebarvalue === "inlp" ? (
                                        <InlpTab />
                                    ) : rightsidebarvalue === "tackandcomment" ? (<TrackChangeandComment getTrigger={getTrigger} />) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                        <Offcanvas show={showOffcanvas} onHide={handleClose}>
                            <div className="offcanvas-body">
                                <Offcanvas.Header>
                                    <Offcanvas.Title>Settings</Offcanvas.Title>
                                    <Button onClick={handleClose} title="Close">
                                        <FaTimes />
                                    </Button>
                                </Offcanvas.Header>
                                <Offcanvas.Body>
                                    {settingGroup.map((item, index) => (
                                        <Form.Group className="form-froup" key={index}>
                                            <Form.Label>{item.label}</Form.Label>
                                            {item.fieldType === 'spellcheck' ? (
                                                <div className="spell-check-settings">
                                                    <div className="toggle-container">
                                                        <Form.Check
                                                            type="switch"
                                                            id="spell-check-switch"
                                                            // label={!spellCheckSettings.enabled ? "Enable Spell Check" : "Disable Spell Check"}
                                                            label={"Spell Check"}
                                                            checked={spellCheckSettings.enabled}
                                                            onChange={(e) => {
                                                                const enabled = e.target.checked;
                                                                const newSettings = {
                                                                    ...spellCheckSettings,
                                                                    enabled,
                                                                    us: true
                                                                };
                                                                setSpellCheckSettings(newSettings);

                                                                const event = new CustomEvent('spellCheckSettingsChanged', {
                                                                    detail: newSettings
                                                                });
                                                                document.dispatchEvent(event);
                                                            }}
                                                        />
                                                    </div>
                                                    {spellCheckSettings.enabled && (
                                                        <div className="language-options">
                                                            <Form.Select
                                                                aria-label="spell-check-language"
                                                                onChange={(e) => handleForm(index, e, item.fieldType)}
                                                                value={item.value}
                                                                style={{ width: '170%' }}
                                                            >
                                                                {item.option.map((list, itemIndex) => (
                                                                    <option value={list.value} key={itemIndex}>
                                                                        {list.label}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                        </div>
                                                    )}
                                                </div>
                                            ) : (
                                                <Form.Select
                                                    id={`setting-select-${index}`}
                                                    aria-label={item.label}
                                                    onChange={(e) => handleForm(index, e, item.fieldType)}
                                                    value={item.value}
                                                >
                                                    {item.option.map((list, itemIndex) => (
                                                        <option value={list.value} key={itemIndex}>
                                                            {list.label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            )}
                                        </Form.Group>
                                    ))}
                                </Offcanvas.Body>
                            </div>
                        </Offcanvas>
                    </div>
                </div>
            )}
            {!logStatus && !articleStatus && (
                <div className={`modal-outer ${isWarning ? 'active' : ''}`} role="dialog" aria-modal="true" style={{ zIndex: 1060 }}>
                    <div className="modal confirmation-popup" style={{ width: '400px' }}>
                        <div className="modal-header">
                            <h1>Session Timeout Warning</h1>
                        </div>
                        <div className="modal-body" style={{ minHeight: 'auto', padding: '20px' }}>
                            {isLoggingOut ? (
                                <p style={{ textAlign: 'center', fontSize: '14px' }}>Saving your work before logging out... Please wait.</p>
                            ) : (
                                <p style={{ textAlign: 'center', fontSize: '14px' }}>You have been inactive for a while. Your session will expire soon. We will automatically save your work before logging you out. Click 'Stay Logged In' to continue.</p>
                            )}
                        </div>
                        <div className="modal-footer" style={{ justifyContent: 'center', borderTop: 'none', paddingBottom: '20px' }}>
                            {!isLoggingOut && (
                                <button className="primary" onClick={resetTimer} style={{ fontSize: '14px', padding: '8px 20px' }}>
                                    Stay Logged In
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Layout;